import { MijnRoute } from '../../mijn-navigatie.model';

export const AUTO_TOP_UP: MijnRoute = {
    path: 'betaalrekening-aanvullen',
    navigationEvent: 'toAutoTopUp',
    regex: /^\/betaalrekening-aanvullen$/,
    webcomponent: 'mijn-auto-top-up-webcomponent'
};
